/* eslint-disable max-len */
import React, { Fragment } from 'react'
import TableBody from './TableBody'
import { useOnClickOutside } from '../../../../../../../../../CommonMethods/OutsideClick';
import { useState,useRef } from 'react';

const BloodGlouseVitalTable=({vitalTabName,pageNumber,List,handleSearchParams,sortValue,setisSortSelected,setConfirmationState,setTextAreaMsg})=>{
    const [selectedIndex, setSelectedIndex] = useState(null); 
    const selectedRef = useRef();
    const urlParams = new URLSearchParams(window.location.search);
    const branchUrl = urlParams.get('sort');

    useOnClickOutside(selectedRef, () => {
        setSelectedIndex(null)
    });

    const handleSort = (key) => {
        setisSortSelected(true)
        if (sortValue === '') handleSearchParams('sort', `${key}+asc`)
        else {
            if (sortValue.includes(key)) handleSearchParams('sort', `${key}+${sortValue.includes('+desc') ? 'asc' : 'desc'}`)
            else handleSearchParams('sort', `${key}+asc`)
        }
    }

    return(
        <div>
            <div className='h-[calc(100vh-382px)] overflow-auto scrollbar_purple pb-2.5' onScroll={()=>setSelectedIndex('')}>
                <table aria-label="Outside Table" className="w-full table-auto">
                    <thead>
                        
                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-0 left-0 z-[1]">
                        <th className="px-[9px] py-2 min-w-[200px]" onClick={() => { handleSort('_id') }} >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Timestamp
                                    <button className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "_id" ? `/images/column-sorting_desc.svg` : '/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            {vitalTabName==='All'&&<th className="px-[9px] py-2 min-w-[180px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Vital Type
                                </span>
                            </th>
                            }
                            <th className="px-[9px] py-2 min-w-[180px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Alert Type
                                </span>
                            </th>
                            
                            <th className="px-[9px] py-2 min-w-[100px]" onClick={() => { handleSort('reading_value') }}>
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading
                                    <button id='reading-value' className="pl-2.5 sortedIcon"><img loading="lazy" decoding="async" src={branchUrl !== undefined && branchUrl?.split("+")[0] === "reading_value" ? `/images/column-sorting_desc.svg` : '/images/column-sorting.svg'} alt="icon" /></button>
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[182px]" >
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Reading Details
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[120px]">
                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Threshold
                                </span>
                            </th>
                            <th className="px-[9px] py-2 min-w-[160px] rounded-tl-sm rounded-bl-sm">
                                <span className="flex items-center text-sm font-normal text-[#000000]">Device ID
                                </span>
                            </th>                           
                        </tr>
                    </thead>
                    <tbody>
                        {List?.historical_reading?.map((item,index)=>(
                            <Fragment key={item._id}>
                                <TableBody
                                    tableData={item}
                                    List={List}
                                    vitalTabName={vitalTabName}
                                    indexNum={index}
                                    pageNumber={pageNumber}
                                    selectedIndex={selectedIndex}
                                    setSelectedIndex={setSelectedIndex}
                                    selectedRef={selectedRef}
                                    lastIndex={List?.data?.length}
                                    setConfirmationState={setConfirmationState}
                                    setTextAreaMsg={setTextAreaMsg}
                                />
                            </Fragment>
                        ))}
                        
        
                    </tbody>
                    
                </table>

            </div>
        </div>
    )
}

export default BloodGlouseVitalTable;